"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconButton = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var IconButton_scss_1 = __importDefault(require("./IconButton.scss"));
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var IconButton = function (props) {
    return (react_1.default.createElement("button", { id: props.id ? props.id : undefined, className: (0, classnames_1.default)(IconButton_scss_1.default['au-icon-btn'], props.className), onClick: props.onClick, disabled: props.disabled, title: props.label },
        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: props.mode })));
};
exports.IconButton = IconButton;
//# sourceMappingURL=IconButton.js.map